<template>
    <div v-show="show" class="position-absolute top left mt-5 ml-2">
        <b-button variant="light" @click="switchLoginMethod">
            <i class="fa-solid fa-chevron-left"></i>
            {{ usingPassword ? '人脸登录' : '密码登录' }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: "SwitchLoginMethod",
    props: {
        show: {
            type: Boolean,
            default: true
        },
        initialMethodIsPassword: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            usingPassword: this.initialMethodIsPassword,
        }
    },
    methods: {
        switchLoginMethod() {
            this.usingPassword = !this.usingPassword
            this.$emit("using-password", this.usingPassword);
        },
    }
}
</script>

<style scoped>

</style>
